// extracted by mini-css-extract-plugin
export default {"error-text":"styles_error-text__+C+G9","wrapper":"styles_wrapper__f4bBO"};